import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import { getInlineLoader } from "../Helpers";
import { FaArrowRight, FaGlobeAfrica, FaAward } from "react-icons/fa";

import aboutImg from '../assets/image1.jpg'; // Path to your main showcase image

export default function HomeAbout(props) {
    const appContext = useContext(AppContext);
    const [ready, setReady] = useState(false);

    async function init() {
        setReady(false);
        // Initialization space
        setReady(true);
    }

    useEffect(() => {
        init();
    }, []);

    if (ready) {
        return (
            <section className="MainBodySection home-about-wrapper">
                <div className="container">
                    <div className="row align-items-center g-4 g-lg-5">
                        
                        {/* Left Column: Clean Single Image Showcase */}
                        <div className="col-12 col-lg-6">
                            <div className="about-clean-image-wrapper position-relative">
                                <img 
                                    src={aboutImg} 
                                    alt="MWADEO Community Impact" 
                                    className="img-fluid about-clean-img"
                                />
                                <div className="about-image-experience-tag d-flex align-items-center gap-2">
                                    <FaAward size={18} className="text-secondary-color" />
                                    <span className="font-semi-bold">Empowering Communities</span>
                                </div>
                            </div>
                        </div>

                        {/* Right Column: Clean Executive Summary */}
                        <div className="col-12 col-lg-6">
                            
                            {/* Subtitle Badge */}
                            <span className="about-clean-tag font-semi-bold text-uppercase mb-2 d-inline-block">
                                Who We Are • MWADEO
                            </span>

                            {/* Main Heading */}
                            <h2 className="title-font-bold about-clean-heading mb-3">
                                Transforming Agriculture & Lifting Living Standards Across Tanzania
                            </h2>

                            {/* Short, Uncluttered Description */}
                            <p className="font-regular about-clean-desc mb-3">
                                Mwananchi Development Organization (MWADEO) is a national non-governmental organization 
                                registered under Act No. 24 of 2002. We work to eliminate poverty by equipping smallholder 
                                farmers and vulnerable groups with modern agricultural skills, education, and climate resilience.
                            </p>

                            {/* Highlights Row */}
                            <div className="row g-3 about-highlights-row mb-4 pt-3">
                                <div className="col-6">
                                    <div className="d-flex align-items-center gap-2">
                                        <div className="about-icon-pill">
                                            <FaAward size={16} />
                                        </div>
                                        <div>
                                            <h6 className="title-font-bold mb-0 text-dark-custom">Registered NGO</h6>
                                            <small className="text-muted-custom">Act No. 24 / 2002</small>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-6">
                                    <div className="d-flex align-items-center gap-2">
                                        <div className="about-icon-pill">
                                            <FaGlobeAfrica size={16} />
                                        </div>
                                        <div>
                                            <h6 className="title-font-bold mb-0 text-dark-custom">National Scope</h6>
                                            <small className="text-muted-custom">United Republic of Tanzania</small>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Clean Call to Action Button */}
                            <button
                                className="btn btn-about-clean title-font-semi-bold d-inline-flex align-items-center gap-2"
                                onClick={() => appContext.navTo({ item: 'about_us' })}
                            >
                                <span>Learn More About Us</span>
                                <FaArrowRight size={14} />
                            </button>

                        </div>

                    </div>
                </div>
            </section>
        );
    } else {
        return (
            <div className="container mSupportLoading d-flex justify-content-center align-items-center" style={{ height: "400px" }}>
                {getInlineLoader()}
            </div>
        );
    }
}